import * as React from 'react';

import {TwoRowItemCard} from 'shells/two-row-item/two-row-item-card';
import {Body} from 'shells/typography/body';

import type {FormFragment_editableVersion_fields_rules_objectsToAssign as ObjectToAssign} from 'nutshell-graphql-types';

type Props = {
    fieldLabel: string;
    selectedOption: string;
    objectToAssign: ObjectToAssign;
    onRemove: () => void;
};

export function AnswerRuleCard(props: Props) {
    return (
        <TwoRowItemCard
            topRow={props.fieldLabel}
            bottomRow={getBottomRow(props.selectedOption, props.objectToAssign)}
            onRemove={props.onRemove}
        />
    );
}

function getBottomRow(selectedOption: string, objectToAssign: ObjectToAssign): React.ReactElement {
    return (
        <div className='flex flex-dir-col'>
            <Body size='small' color='light'>
                is {selectedOption}
            </Body>
            <Body size='small' color='light'>
                <strong>{`Add ${getEntityType(objectToAssign)}: `}</strong>&quot;
                {objectToAssign.name}&quot;
            </Body>
        </div>
    );
}

function getEntityType(object: ObjectToAssign): string {
    switch (object.__typename) {
        case 'Audience':
            return 'audience';
        case 'Product':
            return 'product';
        case 'Source':
            return 'source';
        case 'Tag':
        default:
            return 'tag';
    }
}
